import { PreviewService } from 'app/services/preview.service';
import { ListDossiersService } from 'app/services/list-dossiers.service';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { ListDossiersFinancierService } from 'app/services/list-dossiers-financier.service';
import { FinancierModalComponent } from 'app/shared/financier-modal/financier-modal.component';
import { UploadFileModalComponent } from 'app/shared/upload-file-modal/upload-file-modal.component';
import { environment } from './../../../../../environments/environment';
import { AuthenticationService } from '@alfresco/adf-core';
import { PopupPDFComponent } from 'app/shared/PopupPDFComponent/PopupPDFComponent.component';
import { element } from 'protractor';
import { Logger } from 'selenium-webdriver/lib/logging';
import { RestantDuModalComponent } from 'app/shared/restantDu-modal/restantDu-modal.component';

@Component({
  selector: 'app-consulter-versement',
  templateUrl: './consulter-versement.component.html',
  styleUrls: ['./consulter-versement.component.css'],

})
export class ConsulterVersementComponent implements OnInit {
  @Output() newItemEvent = new EventEmitter();
  @ViewChild (MatPaginator) paginator: MatPaginator;
  select: string[] = ['Créance 1'];
  displayedColumns = ['dateVersement' ,'montantVersement', 'modeReglement', 'typedeversement', 'affectaion', 'delaiVersement','restantDu','restantDuPrincipal','restantDuTotal', 'telecharger', 'payerRestantDu'];
  public versement:any;
  public nomDossier = this.route.snapshot.params.nomDossier;
  //public nomVersement = this.route.snapshot.params.nomVersement;
  public minDate: Date;
  public montant:string;
  public phase: string;
  public baseUrl=`${environment.baseUrl}`
  public ticket=`?alf_ticket=${this.authService.getTicketEcm()}`
  public telecharger: string;
  public nomVersement: string;
  public selectedRestantDu: string;

  constructor(
    private api:PreviewService,
    private financierService :ListDossiersFinancierService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private dossiers :ListDossiersService,
    private authService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.getAllVersements()
    this.getVersement();
  };

  public openDialog() {
    const dialogRef =
    this.dialog.open(FinancierModalComponent, {
          width: '700px',
          height: '600px',
          data: {
            title_label: 'Ajout des versements',
            sub_title_label: `versements`,
            button_label_1: 'Annuler',
            button_label_2: 'OK',
            versement:true,
            frais:false,
            nomDossier: this.nomDossier // Pass nomDossier to the dialog
          }
        });
    dialogRef.afterClosed().subscribe(res => {res ;console.log("after close",res,this.nomDossier)
      this.financierService.CreateVersement(res , this.nomDossier ).subscribe({
        complete: () => {
          this.api.OpenSuccessDialog();
          console.log(' successfully Added versements !!!');
          this.reload()
          this.getVersement()
        },
        error: (e) => {
          console.log(e);
        }})
      });
    }
    reload(){
      setTimeout(()=> {this.getVersement();
        console.log('rfresh 1')},5000);
      setTimeout(()=> {this.getVersement();
        console.log('rfresh 2')},10000);
      setTimeout(()=> {this.getVersement();
        console.log('rfresh 3')},12000);
      setTimeout(()=> {this.getVersement();
        console.log('rfresh 4')},14000);
    }
  getAllVersements() {
    this.dossiers.getDossierByName(this.nomDossier).subscribe((data: any) => {
      this.montant = data.phaseAmiable[0].montantDeCreance;
     // this.nomVersement = data.versement[0].nomVersement;
    });
  }
  getVersement(){
    this.financierService.GetVersement(this.nomDossier).subscribe((data)=>{
      this.versement = new MatTableDataSource(data.Versement);
      this.versement.paginator = this.paginator;
      console.log(data.Versement);
    })
  }

  selectedVersement(element: any){
    //this.nomVersement = element;
    //console.log("selectedRow " + this.nomVersement);
  }

  selectedRestantDuVers(element: any){
    //this.selectedRestantDu = element;
    //console.log("selectedRestantDu " + this.selectedRestantDu);
  }

  openPDFPopup(element): void {
    this.nomVersement = element;
    console.log("selectedRow " + this.nomVersement);
    const dialogRef = this.dialog.open(PopupPDFComponent, {
      width: '50%',
      height: '80%',
      data: {
        baseUrl: this.baseUrl,
        nomDossier: this.nomDossier,
        nomVersement: this.nomVersement,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('La popup PDF est fermée');
    });
  }

  restantDuPopup(element) {
    this.nomVersement = element;
    console.log("selectedRow " + this.nomVersement);
    const dialogRef =
    this.dialog.open(RestantDuModalComponent, {
          width: '800px',
          height: '250px',
          data: {
            title_label: 'Vous voulez vraiment confirme le paiement des Restant du',
            sub_title_label: `versements`,
            button_label_1: 'Annuler',
            button_label_2: 'OK',
            nomDossier: this.nomDossier, // Pass nomDossier to the dialog
            nomVersement: this.nomVersement,
            selectedRestantDu: this.selectedRestantDu,
          }
        });
    dialogRef.afterClosed().subscribe(res => {res ;console.log("after close",res,this.nomDossier)
      this.financierService.updateRestantDu(this.nomDossier, this.nomVersement, res ).subscribe({
        complete: () => {
          this.api.OpenSuccessDialog();
          console.log(' successfully Added versements !!!');
          this.reload()
          this.getVersement()
        },
        error: (e) => {
          console.log(e);
        }})
      });
    }
}


